import yup from 'src/libraries/validator.library';
import {
  RopeTypeSchema,
  IRopeTypeForm,
  RopeTypeResponsePayloadSchema,
} from 'src/models/rope-type.model';
import { httpClient } from 'src/libraries/http.library';

const http = httpClient();

const services = {
  listGET: async () => {
    return http.get('ropeTypes', { limit: 0 }, RopeTypeSchema);
  },
  updatePUT: async (id: number, data: IRopeTypeForm) => {
    return http.put(`ropeTypes/${id}`, data, RopeTypeResponsePayloadSchema);
  },
  addPOST: async (data: IRopeTypeForm) => {
    return http.post('ropeTypes', data, RopeTypeResponsePayloadSchema);
  },
  itemDELETE: async (id: number) => {
    return http.delete(`ropeTypes/${id}`, yup.mixed());
  },
};

export default services;
